(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[769],{

/***/ 25068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ INITIAL_VALUES; },
/* harmony export */   "T1": function() { return /* binding */ VALIDATION_SCHEMA; },
/* harmony export */   "tl": function() { return /* binding */ CONSTANTS; }
/* harmony export */ });
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97336);

var URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;
var phoneRegex = /^\+?[\d\s]+$/;
var INITIAL_VALUES = {
    client: {
        name: "",
        website: "",
        location_attributes: {
            full_address: "",
            place_id: ""
        },
        ai_access: true,
        super_account_owner_attributes: {
            user_attributes: {
                contact_no: "",
                email: "",
                name: ""
            }
        },
        client_branding_attributes: {
            email_logo: "",
            logo: "",
            sidebar_logo: "",
            primary_color_hex: "",
            logo_branding: false,
            sidebar_logo_branding: false
        }
    }
};
var VALIDATION_SCHEMA = _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
    client: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        name: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:required")),
        website: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(URL_FORMAT, (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:invalid_website")),
        super_account_owner_attributes: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            user_attributes: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                name: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                contact_no: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")).min(8, (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_short")).max(20, (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_long")).nullable(true),
                email: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().email((0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).required((0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
            })
        }),
        location_attributes: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            full_address: _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:required")).nullable(true).test("validLocation", "Invalid address, Please select from the dropdown", function(value) {
                return this.parent.place_id && this.parent.place_id.length > 0;
            })
        })
    })
});
var CONSTANTS = {
    brand_logo: {
        file_size: 200,
        file_height: 50,
        file_width: 184,
        dimension_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_brand_logo:dimension_error_message"),
        size_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_brand_logo:size_error_message")
    },
    email_logo: {
        file_size: 100,
        file_height: 100,
        file_width: 365,
        dimension_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_email_logo:dimension_error_message"),
        size_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_email_logo:size_error_message")
    },
    sidebar_logo: {
        file_size: 200,
        file_height: 100,
        file_width: 100,
        dimension_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_sidebar_logo:dimension_error_message"),
        size_error_message: (0,_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("company_sidebar_logo:dimension_error_message")
    }
};


/***/ }),

/***/ 97336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "OC": function() { return /* reexport */ AdminClientNewAction; },
  "PG": function() { return /* reexport */ common/* AutocompleteError */.PG; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "tl": function() { return /* reexport */ clients_new/* CONSTANTS */.tl; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "KU": function() { return /* reexport */ Client; },
  "CJ": function() { return /* reexport */ common/* Congrats */.CJ; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "N7": function() { return /* reexport */ clients_new/* INITIAL_VALUES */.N7; },
  "pd": function() { return /* reexport */ input_error/* InputError */.p; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "Oj": function() { return /* reexport */ (congrats_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "T1": function() { return /* reexport */ clients_new/* VALIDATION_SCHEMA */.T1; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "GB": function() { return /* reexport */ response_handler/* handleOtherResponseCode */.G; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: AnimatePresence, Component, ErrorMessage, Field, FieldArray, FontAwesomeIcon, Image, Link, MobileMenubar, NextServerCookies, React, Sidebar, faExclamationCircle, faTimes, getIn, getSession, goToNextPage, nextStep, signIn, toastr, useNavbarStatus

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./src/actions/pages/admins/dashboard/clients/new.js






function nextStep(setButtonPopup, link, router) {
    router.push(link);
    setButtonPopup(false);
}
function isItUpdateAction() {
    var client_id = new common/* DataFromUrl */.QJ().getClientId();
    return client_id ? true : false;
}
var AdminClientNewAction = /*#__PURE__*/ function() {
    "use strict";
    function AdminClientNewAction(setApiError, formRef, setFlagForRender, selectedBrandLogo, selectedEmailLogo, selectedSidebarLogo) {
        (0,_class_call_check/* default */.Z)(this, AdminClientNewAction);
        this.setApiError = setApiError;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.formRef = formRef;
        this.setFlagForRender = setFlagForRender;
        this.selectedBrandLogo = selectedBrandLogo;
        this.selectedEmailLogo = selectedEmailLogo;
        this.selectedSidebarLogo = selectedSidebarLogo;
    }
    (0,_create_class/* default */.Z)(AdminClientNewAction, [
        {
            key: "selectFile",
            value: function selectFile(selectedFile1, setSelectedFile, type) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var preview_container_id, image_height, image_width, drop_down_container, field_name;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                preview_container_id = null;
                                image_height = null;
                                image_width = null;
                                drop_down_container = null;
                                field_name = null;
                                if (type == "brand_logo") {
                                    preview_container_id = "brand_logo_preview";
                                    image_height = clients_new/* CONSTANTS.brand_logo.file_height */.tl.brand_logo.file_height;
                                    image_width = clients_new/* CONSTANTS.brand_logo.file_width */.tl.brand_logo.file_width;
                                    drop_down_container = "brand_logo_preview_drag_drop";
                                    field_name = "client.client_branding_attributes.logo";
                                } else if (type == "sidebar_logo") {
                                    preview_container_id = "sidebar_logo_preview";
                                    image_height = clients_new/* CONSTANTS.sidebar_logo.file_height */.tl.sidebar_logo.file_height;
                                    image_width = clients_new/* CONSTANTS.sidebar_logo.file_width */.tl.sidebar_logo.file_width;
                                    drop_down_container = "sidebar_logo_preview_drag_drop";
                                    field_name = "client.client_branding_attributes.sidebar_logo";
                                } else {
                                    preview_container_id = "email_logo_preview";
                                    image_height = clients_new/* CONSTANTS.email_logo.file_height */.tl.email_logo.file_height;
                                    image_width = clients_new/* CONSTANTS.email_logo.file_width */.tl.email_logo.file_width;
                                    drop_down_container = "email_logo_preview_drag_drop";
                                    field_name = "client.client_branding_attributes.email_logo";
                                }
                                _this.remove_error(type);
                                return [
                                    4,
                                    _this.checkFileDimentions(selectedFile1, image_height, image_width, type)
                                ];
                            case 1:
                                if (_state.sent() && _this.checkFileSize(selectedFile1, type)) {
                                    setSelectedFile(selectedFile1);
                                    _this.setPreviewImage(selectedFile1, preview_container_id);
                                    _this.hideDropdown(drop_down_container);
                                    _this.showPreviewImage(preview_container_id);
                                    _this.setImageData(field_name, selectedFile1);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deselectFile",
            value: function deselectFile(event, index, setSelectedFile) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedFile[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var file = _step.value;
                        selectedFile.splice(index, 1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setSelectedFile(selectedFile);
            }
        },
        {
            key: "checkFileDimentions",
            value: function checkFileDimentions(selected_file, validationHeight, validationWidth, type) {
                var k_this = this;
                var promise = new Promise(function(resolve, reject) {
                    var error = type == "brand_logo" ? clients_new/* CONSTANTS.brand_logo.dimension_error_message */.tl.brand_logo.dimension_error_message : type == "sidebar_logo" ? clients_new/* CONSTANTS.sidebar_logo.dimension_error_message */.tl.sidebar_logo.dimension_error_message : clients_new/* CONSTANTS.email_logo.dimension_error_message */.tl.email_logo.dimension_error_message;
                    var reader = new FileReader();
                    if (typeof selected_file != "undefined") {
                        reader.readAsDataURL(selected_file);
                        reader.onload = function(event) {
                            var imageFile = new Image();
                            imageFile.src = event.target.result;
                            imageFile.onload = function(event) {
                                var image_height = event.target.height;
                                var image_width = event.target.width;
                                if (image_height < validationHeight || image_width < validationWidth) {
                                    k_this.set_image_error(type, error);
                                    resolve(false);
                                } else {
                                    resolve(true);
                                }
                            };
                        };
                    } else {
                        k_this.remove_error(type);
                        resolve(false);
                    }
                });
                return promise;
            }
        },
        {
            key: "checkFileSize",
            value: function checkFileSize(selected_file, type) {
                var error = type == "brand_logo" ? clients_new/* CONSTANTS.brand_logo.size_error_message */.tl.brand_logo.size_error_message : type == "sidebar_logo" ? clients_new/* CONSTANTS.sidebar_logo.size_error_message */.tl.sidebar_logo.size_error_message : clients_new/* CONSTANTS.email_logo.size_error_message */.tl.email_logo.size_error_message;
                var maxFileSize = type == "brand_logo" ? clients_new/* CONSTANTS.brand_logo.file_size */.tl.brand_logo.file_size : type == "sidebar_logo" ? clients_new/* CONSTANTS.sidebar_logo.file_size */.tl.sidebar_logo.file_size : clients_new/* CONSTANTS.email_logo.file_size */.tl.email_logo.file_size;
                if (selected_file.size / 1024 > maxFileSize) {
                    this.set_image_error(type, error);
                    return false;
                } else {
                    return true;
                }
            }
        },
        {
            key: "openHiddenFileUploader",
            value: function openHiddenFileUploader(hiddenInputRef) {
                hiddenInputRef.current.click();
            }
        },
        {
            key: "formImagesAreValid",
            value: function formImagesAreValid(values) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                return (((ref = values.client.client_branding_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.email_logo) === null || ref1 === void 0 ? void 0 : ref1.size) > 0 || typeof ((ref2 = values.client.client_branding_attributes) === null || ref2 === void 0 ? void 0 : ref2.email_logo) == "string" && ((ref3 = values.client.client_branding_attributes) === null || ref3 === void 0 ? void 0 : ref3.email_logo) != "") && (((ref4 = values.client.client_branding_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.logo) === null || ref5 === void 0 ? void 0 : ref5.size) > 0 || typeof ((ref6 = values.client.client_branding_attributes) === null || ref6 === void 0 ? void 0 : ref6.logo) == "string" && ((ref7 = values.client.client_branding_attributes) === null || ref7 === void 0 ? void 0 : ref7.logo) != "");
            }
        },
        {
            key: "setFormImagesErrors",
            value: function setFormImagesErrors(values) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                var error = "Required";
                if (typeof ((ref = values.client.client_branding_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.email_logo) === null || ref1 === void 0 ? void 0 : ref1.size) == "undefined") {
                    this.set_image_error("email_logo", error);
                }
                if (typeof ((ref2 = values.client.client_branding_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.logo) === null || ref3 === void 0 ? void 0 : ref3.size) == "undefined") {
                    this.set_image_error("brand_logo", error);
                }
                if (typeof ((ref4 = values.client.client_branding_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sidebar_logo) === null || ref5 === void 0 ? void 0 : ref5.size) == "undefined") {
                    this.set_image_error("sidebar_logo", error);
                }
            }
        },
        {
            key: "set_image_error",
            value: function set_image_error(type, error) {
                if (type == "brand_logo") {
                    if (typeof this.formRef.current.status == "undefined") {
                        this.formRef.current.setStatus({
                            client: {
                                client_branding_attributes: {
                                    logo: error
                                }
                            }
                        });
                    } else {
                        this.formRef.current.status.client.client_branding_attributes["logo"] = error;
                        this.formRef.current.setStatus(this.formRef.current.status);
                    }
                } else if (type == "sidebar_logo") {
                    if (typeof this.formRef.current.status == "undefined") {
                        this.formRef.current.setStatus({
                            client: {
                                client_branding_attributes: {
                                    sidebar_logo: error
                                }
                            }
                        });
                    } else {
                        this.formRef.current.status.client.client_branding_attributes["sidebar_logo"] = error;
                        this.formRef.current.setStatus(this.formRef.current.status);
                    }
                } else {
                    if (typeof this.formRef.current.status == "undefined") {
                        this.formRef.current.setStatus({
                            client: {
                                client_branding_attributes: {
                                    email_logo: error
                                }
                            }
                        });
                    } else {
                        this.formRef.current.status.client.client_branding_attributes["email_logo"] = error;
                        this.formRef.current.setStatus(this.formRef.current.status);
                    }
                }
            }
        },
        {
            key: "remove_error",
            value: function remove_error(type) {
                if (type == "brand_logo") {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    if (this.formRef.current.error && ((ref = this.formRef.current.error) === null || ref === void 0 ? void 0 : (ref1 = ref.client) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.client_branding_attributes) === null || ref2 === void 0 ? void 0 : ref2.logo)) {
                        this.formRef.current.error.client.client_branding_attributes.logo = "";
                    } else if (this.formRef.current.status && ((ref3 = this.formRef.current.status) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.client) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.client_branding_attributes) === null || ref5 === void 0 ? void 0 : ref5.logo)) {
                        this.formRef.current.status.client.client_branding_attributes.logo = "";
                    }
                } else if (type == "sidebar_logo") {
                    var ref6, ref7, ref8, ref9, ref10, ref11;
                    if (this.formRef.current.error && ((ref6 = this.formRef.current.error) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.client) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.client_branding_attributes) === null || ref8 === void 0 ? void 0 : ref8.sidebar_logo)) {
                        this.formRef.current.error.client.client_branding_attributes.sidebar_logo = "";
                    } else if (this.formRef.current.status && ((ref9 = this.formRef.current.status) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.client) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.client_branding_attributes) === null || ref11 === void 0 ? void 0 : ref11.sidebar_logo)) {
                        this.formRef.current.status.client.client_branding_attributes.sidebar_logo = "";
                    }
                } else {
                    var ref12, ref13, ref14, ref15, ref16, ref17;
                    if (this.formRef.current.error && ((ref12 = this.formRef.current.error) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.client) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.client_branding_attributes) === null || ref14 === void 0 ? void 0 : ref14.email_logo)) {
                        this.formRef.current.error.client.client_branding_attributes.email_logo = "";
                    } else if (this.formRef.current.status && ((ref15 = this.formRef.current.status) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.client) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.client_branding_attributes) === null || ref17 === void 0 ? void 0 : ref17.email_logo)) {
                        this.formRef.current.status.client.client_branding_attributes.email_logo = "";
                    }
                }
            }
        },
        {
            key: "setPreviewImage",
            value: function setPreviewImage(selected_file, preview_container_id) {
                var reader = new FileReader();
                reader.readAsDataURL(selected_file);
                reader.onload = function(event) {
                    document.querySelector("#".concat(preview_container_id)).src = event.target.result;
                };
            }
        },
        {
            key: "hideDropdown",
            value: function hideDropdown(dropDownId) {
                var drop_down = document.querySelector("#".concat(dropDownId));
                drop_down.style.display = "none";
            }
        },
        {
            key: "showPreviewImage",
            value: function showPreviewImage(previewImageId) {
                var drop_down = document.querySelector("#".concat(previewImageId)).closest(".logo_preview_container");
                drop_down.style.display = "block";
            }
        },
        {
            key: "setImageData",
            value: function setImageData(name, value) {
                this.formRef.current.setFieldValue(name, value);
            }
        },
        {
            key: "dragOver",
            value: function dragOver(e) {
                e.preventDefault();
            }
        },
        {
            key: "dragEnter",
            value: function dragEnter(e) {
                e.preventDefault();
            }
        },
        {
            key: "dragLeave",
            value: function dragLeave(e) {
                e.preventDefault();
            }
        },
        {
            key: "fileDrop",
            value: function fileDrop(e) {
                e.preventDefault();
                var files = e.dataTransfer.files;
                if (files.length) {
                    handleFiles(files);
                }
            }
        },
        {
            key: "setDragDropClass",
            value: function setDragDropClass(link) {
                if ((link === null || link === void 0 ? void 0 : link.length) > 0) {
                    return "hideDragAndDrop";
                } else {
                    return "";
                }
            }
        },
        {
            key: "setPreviewImageClass",
            value: function setPreviewImageClass(link) {
                if ((link === null || link === void 0 ? void 0 : link.length) > 0) {
                    return "showPreview";
                } else {
                    return "";
                }
            }
        },
        {
            key: "handleFormSubmit",
            value: function handleFormSubmit(values, router, t, setButtonPopup, setClientId, setApiError, selectedEmailLogo, selectedBrandLogo, selectedSidebarLogo) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, result, formData, _tmp, client_id, status_code, response, link, ref3, ref4, ref5, ref6, ref7, ref8, error, error1, responseError;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formData = new FormData();
                                // if(this.formImagesAreValid(values))
                                // {
                                formData.append("client[name]", values.client.name);
                                formData.append("client[website]", values.client.website);
                                formData.append("client[ai_access]", values.client.ai_access);
                                formData.append("client[check_location_validation]", true);
                                if (values.client.location_attributes.id) formData.append("client[location_attributes][id]", values.client.location_attributes.id);
                                if (values.client.location_attributes.place_id) formData.append("client[location_attributes][place_id]", values.client.location_attributes.place_id);
                                formData.append("client[location_attributes][full_address]", values.client.location_attributes.full_address);
                                // formData.append("client[daxtra_db_name]", values.client.daxtra_db_name);
                                // formData.append("client[daxtra_db_username]", values.client.daxtra_db_username);
                                // formData.append("client[daxtra_db_password]", values.client.daxtra_db_password);
                                if (values.client.super_account_owner_attributes.id) formData.append("client[super_account_owner_attributes][id]", values.client.super_account_owner_attributes.id);
                                if (values.client.super_account_owner_attributes.user_attributes.id) formData.append("client[super_account_owner_attributes][user_attributes][id]", values.client.super_account_owner_attributes.user_attributes.id);
                                formData.append("client[super_account_owner_attributes][user_attributes][contact_no]", values.client.super_account_owner_attributes.user_attributes.contact_no);
                                formData.append("client[super_account_owner_attributes][user_attributes][email]", values.client.super_account_owner_attributes.user_attributes.email);
                                formData.append("client[super_account_owner_attributes][user_attributes][name]", values.client.super_account_owner_attributes.user_attributes.name);
                                _tmp = {};
                                //client_branding_attributes
                                values.client.client_branding_attributes.id != null ? formData.append("client[client_branding_attributes][id]", values.client.client_branding_attributes.id || _tmp) : "";
                                typeof selectedEmailLogo == "undefined" ? "" : formData.append("client[client_branding_attributes][email_logo]", selectedEmailLogo);
                                typeof selectedBrandLogo == "undefined" ? "" : formData.append("client[client_branding_attributes][logo]", selectedBrandLogo);
                                typeof selectedSidebarLogo == "undefined" ? "" : formData.append("client[client_branding_attributes][sidebar_logo]", selectedSidebarLogo);
                                formData.append("client[client_branding_attributes][primary_color_hex]", ((ref = values.client.client_branding_attributes) === null || ref === void 0 ? void 0 : ref.primary_color_hex) || "");
                                formData.append("client[client_branding_attributes][logo_branding]", (ref1 = values.client.client_branding_attributes) === null || ref1 === void 0 ? void 0 : ref1.logo_branding);
                                formData.append("client[client_branding_attributes][sidebar_logo_branding]", (ref2 = values.client.client_branding_attributes) === null || ref2 === void 0 ? void 0 : ref2.sidebar_logo_branding);
                                if (!isItUpdateAction()) return [
                                    3,
                                    2
                                ];
                                client_id = new common/* DataFromUrl */.QJ().getClientId();
                                return [
                                    4,
                                    new Client().updateClient(formData, client_id)
                                ];
                            case 1:
                                // result = await new Client().updateClient(values, client_id);
                                result = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    new Client().createClient(formData)
                                ];
                            case 3:
                                // result = await new Client().createClient(values);
                                result = _state.sent();
                                _state.label = 4;
                            case 4:
                                setApiError(result.request);
                                status_code = result.status || result.response.status;
                                switch(status_code){
                                    case common/* SUCCESS_REPONSE_CODE */.Us:
                                        response = result.data;
                                        if (response.success) {
                                            if (isItUpdateAction()) {
                                                link = common/* REDIRECT.admins.dashboard.clients.users.replace */.RQ.admins.dashboard.clients.users.replace("$client_id", response.slug);
                                                nextStep(setButtonPopup, common/* REDIRECT.admins.dashboard.clients.users.replace */.RQ.admins.dashboard.clients.users.replace("$client_id", response.slug), router);
                                            } else {
                                                setButtonPopup(true);
                                            }
                                            setClientId(response.slug);
                                        } else {
                                            console.log(response.error);
                                        }
                                        break;
                                    case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                                        ;
                                        if (((ref3 = result.response.data.error.client) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.client_branding_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.email_logo) === null || ref5 === void 0 ? void 0 : ref5.length) > 0) {
                                            error = result.response.data.error.client.client_branding_attributes.email_logo;
                                            _this.set_image_error("email_logo", error);
                                        } else if (((ref6 = result.response.data.error.client) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.client_branding_attributes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.logo) === null || ref8 === void 0 ? void 0 : ref8.length) > 0) {
                                            error1 = result.response.data.error.client.client_branding_attributes.logo;
                                            _this.set_image_error("brand_logo", error1);
                                        }
                                        if (typeof result.response.data.error === "string") {
                                            new common/* CustomToastrAction */.Y5().setNormalToastr(result.response.data.error, "error");
                                        } else {
                                            responseError = result.response.data.error;
                                            if (responseError.client.full_address) {
                                                responseError.client["location_attributes"] = {};
                                                responseError.client.location_attributes["full_address"] = responseError.client.full_address;
                                                delete result.response.data.error.client["full_address"];
                                            }
                                            return [
                                                2,
                                                result.response.data.error
                                            ];
                                        }
                                        break;
                                    default:
                                        (0,response_handler/* handleOtherResponseCode */.G)(status_code, router);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                // }
                // else
                // {
                //     this.setFormImagesErrors(values);
                // }
                })();
            }
        },
        {
            key: "setInitialProps",
            value: function setInitialProps(data) {
                var ref;
                if (data === null || data === void 0 ? void 0 : (ref = data.client) === null || ref === void 0 ? void 0 : ref.client_branding_attributes) {
                    var ref1, ref2, ref3;
                    data.client.client_branding_attributes["email_logo"] = (ref1 = data.client.client_branding_attributes) === null || ref1 === void 0 ? void 0 : ref1.email_logo_url;
                    data.client.client_branding_attributes["logo"] = (ref2 = data.client.client_branding_attributes) === null || ref2 === void 0 ? void 0 : ref2.logo_url;
                    data.client.client_branding_attributes["sidebar_logo"] = (ref3 = data.client.client_branding_attributes) === null || ref3 === void 0 ? void 0 : ref3.sidebar_logo_url;
                }
                return data;
            }
        }
    ]);
    return AdminClientNewAction;
}();

// EXTERNAL MODULE: ./src/actions/common/response-handler.js
var response_handler = __webpack_require__(24906);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/admins/dashboard/clients/new.js







var Client = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(Client, SendRequest);
    var _super = (0,_create_super/* default */.Z)(Client);
    function Client() {
        (0,_class_call_check/* default */.Z)(this, Client);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Client, [
        {
            key: "createClient",
            value: function createClient(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.admins.dashboard.clients.company.CREATE */.bl.admins.dashboard.clients.company.CREATE, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateClient",
            value: function updateClient(params, clientId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.patch */.od.patch(common/* API.admins.dashboard.clients.company.UPDATE.replace */.bl.admins.dashboard.clients.company.UPDATE.replace("$client_id", clientId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Client;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/constants/pages/admins/dashboard/clients/new.js
var clients_new = __webpack_require__(25068);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/new/_index.module.scss
var _index_module = __webpack_require__(10994);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/congrats/_index.module.scss
var congrats_index_module = __webpack_require__(66772);
var congrats_index_module_default = /*#__PURE__*/__webpack_require__.n(congrats_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/admins/dashboard/clients/new.js
//* This file contains the export files statement which will be export again in the pages
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- Actions ---------------------



// ----------------- Action ---------------------
// --------------------Services----------


// ------------------Services-----------
// -----------------------------  CONSTANTS -----------------------------

// -----------------------------  CONSTANTS -----------------------------
// ----------------- Stylesheet ---------------------

 // ----------------- Stylesheet ---------------------


/***/ }),

/***/ 66772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"congrats_Modalpopup__8IiAe","Modalpopup__inner":"congrats_Modalpopup__inner__WebUA","Modalpopup__Dialog":"congrats_Modalpopup__Dialog__ymDL_","transition":"congrats_transition__jhud1","Modalpopup__CloseCenter":"congrats_Modalpopup__CloseCenter__hHpe3","Modalpopup__Content":"congrats_Modalpopup__Content__6p9W6","Modalpopup__btn":"congrats_Modalpopup__btn__AkwYM","mar":"congrats_mar__xxYWn","Otpback":"congrats_Otpback__gsOFx"};

/***/ }),

/***/ 10994:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"new_Form__FEtzW","Form__width":"new_Form__width__i_Cc8","Form__label":"new_Form__label__vtVR_","Form__textleft":"new_Form__textleft__ht1KH","Form__InputFullWidth":"new_Form__InputFullWidth__j82ZO","Form__Input":"new_Form__Input__4fB4X","Form__Input398":"new_Form__Input398__5Xpbe","Form__InputSection":"new_Form__InputSection__m_eX_","Form__ScoreCardInput":"new_Form__ScoreCardInput__Bn1iK","Form__Textarea":"new_Form__Textarea___0X0t","primarybtn":"new_primarybtn__Gjsgm","secondarybtn":"new_secondarybtn__C3afM","iconFilled":"new_iconFilled__XXlFl","iconFilledSolid":"new_iconFilledSolid__Oj1wS","primarybtnborder":"new_primarybtnborder__u6Q1l","secondarybtnborder":"new_secondarybtnborder__zmlDw","tertiarybtn":"new_tertiarybtn___qicA","graybtnborder":"new_graybtnborder__JBdU4","jobsrchbtn":"new_jobsrchbtn__kSyZV","jobsrchbtnalign":"new_jobsrchbtnalign__2l72k","nobgbutton":"new_nobgbutton___lDXJ","iconTextButton":"new_iconTextButton__H42ep","cursornone":"new_cursornone__7r3Mn","nobgbuttonprimary":"new_nobgbuttonprimary__q2JkL","mt15":"new_mt15__5F_qn","btn350":"new_btn350__SHjhJ","GrayBgBtn":"new_GrayBgBtn__nyW3a","NewShareBtn":"new_NewShareBtn__Jcvvv","CoralBgBtn":"new_CoralBgBtn__IaopZ","DropContainer":"new_DropContainer__BCr7G","DropContainer__Inner":"new_DropContainer__Inner__wy7He","CompanyProfile__Inner":"new_CompanyProfile__Inner__hNSZ0","DropContainer__Message":"new_DropContainer__Message__WhQMO","CompanyProfile__Message":"new_CompanyProfile__Message__1lBuY","CompanyProfile__MessageContent":"new_CompanyProfile__MessageContent__0H3K2","DropContainer__UploadIcon":"new_DropContainer__UploadIcon__W0MWS","CompanyProfile__UploadIcon":"new_CompanyProfile__UploadIcon__CCShJ","FileDisplayContainer":"new_FileDisplayContainer__GIr0f","FileDisplayContainer__Status":"new_FileDisplayContainer__Status__rg9xa","FileDisplayContainer__Type":"new_FileDisplayContainer__Type__9zang","FileDisplayContainer__Name":"new_FileDisplayContainer__Name__cDSvE","FileDisplayContainer__Error":"new_FileDisplayContainer__Error__XV3MP","FileDisplayContainer__Close":"new_FileDisplayContainer__Close__H4o8b","Browse":"new_Browse__mlD1D","ClientCompany":"new_ClientCompany__U_mAx","ClientCompany__TopSection2":"new_ClientCompany__TopSection2__jituv","ClientCompany__Filter":"new_ClientCompany__Filter__IVqyi","ClientCompany__Input_MatchScore":"new_ClientCompany__Input_MatchScore__WTBwh","ClientCompany__Percentage_Symbol":"new_ClientCompany__Percentage_Symbol__gsTsF","ClientCompany__Filterheading":"new_ClientCompany__Filterheading__8JE_8","ClientCompany__FloatButtonAdd":"new_ClientCompany__FloatButtonAdd__qMiC0","ClientCompany__FloatButtonAdd__AgencyUserIcon":"new_ClientCompany__FloatButtonAdd__AgencyUserIcon__4bYub","ClientCompany__LastEdited":"new_ClientCompany__LastEdited__O_sv4","ClientCompany__BackSection":"new_ClientCompany__BackSection___ag8g","ClientCompany__BackSection__CloseIcon":"new_ClientCompany__BackSection__CloseIcon__C_Y1l","ClientCompany__Container":"new_ClientCompany__Container__SdBFm","ClientCompany__FormInputSection":"new_ClientCompany__FormInputSection__WarXz","CompanyProfile__FormInputSection":"new_CompanyProfile__FormInputSection___lkNP","ClientCompany__Heading":"new_ClientCompany__Heading__KzyRE","ClientCompany__StatusAlignment":"new_ClientCompany__StatusAlignment__H0L_f","ClientCompany__Status":"new_ClientCompany__Status__e6u1A","ClientCompany__ActiveDot":"new_ClientCompany__ActiveDot__nvc6B","ClientCompany__CloseDot":"new_ClientCompany__CloseDot__us0im","ClientCompany__Company":"new_ClientCompany__Company__SaWsc","ClientCompany__Systemrefheding":"new_ClientCompany__Systemrefheding__2kUZ3","ClientCompany__Subheading":"new_ClientCompany__Subheading__ksX5x","CompanyProfile__Subheading":"new_CompanyProfile__Subheading__gwu7E","ClientCompany__Subheading2":"new_ClientCompany__Subheading2__5Iig_","ClientCompany__Description":"new_ClientCompany__Description__rRKf1","ClientCompany__SubmitSection":"new_ClientCompany__SubmitSection__7034E","ClientCompany__IntegrationImage":"new_ClientCompany__IntegrationImage__CoIHW","ClientCompany__QuickAdd":"new_ClientCompany__QuickAdd__TG5pS","ClientCompany__BodyText":"new_ClientCompany__BodyText__YLnDW","Form__TableRow":"new_Form__TableRow__WnwMq","Form__Label":"new_Form__Label___5hyW","Form__FloatingLabel":"new_Form__FloatingLabel__L6DTJ","Form__TableCol":"new_Form__TableCol__XR1sC","Form__currency_symbol":"new_Form__currency_symbol__Ft3vq","Form__CustomSelect":"new_Form__CustomSelect__2oDa9","Form__currency_symbol__right":"new_Form__currency_symbol__right__BW44v","Form__TableCol__Disabled":"new_Form__TableCol__Disabled__xg9Hn","Form__TextareaDisabled":"new_Form__TextareaDisabled__MFx2j","Form__EditorDisabled":"new_Form__EditorDisabled__yzmkT","Form__AdminCheckLabel":"new_Form__AdminCheckLabel__J1PS4","Form__AdminCheckMargin":"new_Form__AdminCheckMargin__t9SVG","CompanyProfile__BrandingGuide":"new_CompanyProfile__BrandingGuide__1hx7D","CompanyProfile__DropBoxContainer":"new_CompanyProfile__DropBoxContainer__e4shz","CompanyProfile__Browse":"new_CompanyProfile__Browse__oKEzs","ErrorLabel":"new_ErrorLabel__ZwYtP","Height80":"new_Height80__FonGK","Browse__ButtonFlexEnd":"new_Browse__ButtonFlexEnd__j6xZr","AddAgency__Container":"new_AddAgency__Container__Q7Ib_","AddAgency__FormInputSection":"new_AddAgency__FormInputSection__P_nWy","AddAgency__FormInputSection__Label":"new_AddAgency__FormInputSection__Label__p8aDT","AddAgency__Form":"new_AddAgency__Form__IjRhN","LinkAsButtons":"new_LinkAsButtons__QQ1f9","SearchFlex":"new_SearchFlex__LJiVM","IntegrationTable":"new_IntegrationTable__ceFF9","Form__MessagePlaceholder":"new_Form__MessagePlaceholder__QktbT"};

/***/ })

}]);